<div class="col-12">
  <div>
      <span>Note: Impacts should be submitted on or before {{impactdate}}</span>
  </div>
</div>
<div class="col-12">
  <!--<form [formGroup]="reviewForm" autocomplete="off">
      <div class="row" style="margin-top: 20px;">
          <div class="col-xl-1 col-lg-2 col-md-4 col-sm-6 col-xs-12" style="margin-right: 50px;" *ngFor="let impact of impactType;let i=index">
              <mat-checkbox (change)="onChange(impact.deD_Id,i)" formControlName="active">{{impact.deD_Description}}</mat-checkbox>
              <mat-form-field>
                  <input matInput [readonly]="checkDisable(i)" type="text" value='' formControlName="{{impact.deD_Short_Description}}">
              </mat-form-field>
          </div>
      </div>
  </form>-->
  <kendo-grid [kendoGridBinding]="impactList" [pageable]="true" [selectable]="true" [sortable]="true" [resizable]="true" [pageSize]="15" (selectionChange)="onSelectionChange($event)" (excelExport)="onExcelExport($event)" [filterable]="enableFilter">
    <ng-template kendoPagerTemplate>
      <div class="k-pager-left">
        <kendo-pager-info></kendo-pager-info>
      </div>
      <div class="k-pager-right">
        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
        <kendo-pager-input></kendo-pager-input>
        <kendo-pager-next-buttons></kendo-pager-next-buttons>
      </div>
    </ng-template>
    <ng-template kendoGridToolbarTemplate>
      <div class="k-grid-toolbar-content d-flex justify-content-end">
        <div class="icons-container">
          <div class="icon-wrap">
            <i class="fa fa-chain" title="Create Impact" (click)="addImpacts()" aria-hidden="true"></i>
          </div>
          <div class="icon-wrap">
            <i class="fa fa-filter" title="Filter" (click)="toggleFilter()" aria-hidden="true"></i>
          </div>
          <div class="icon-wrap">
            <button type="button" class="btn btn-primary eip-ml-20 eip-mr-20 eip-p-10" style="background: #1579ab;padding: 5px;" kendoGridExcelCommand icon="file-excel">
              Export to
              Excel
            </button>
          </div>
        </div>
      </div>
    </ng-template>
    <kendo-grid-column title="Sl.No." width="60">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        {{rowIndex+1}}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-checkbox-column showSelectAll="true" width="50">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        <div *ngIf="dataItem.responder_Agreed =='Comply'">
          <input [kendoGridSelectionCheckbox]="rowIndex" />
        </div>
      </ng-template>
    </kendo-grid-checkbox-column>
    <kendo-grid-column title="Discipline" field="discipline" width="100">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        <span class="no-wrap" eipTooltip="{{dataItem.discipline}}" eipTooltipPosition="auto">
          {{dataItem.discipline}}
        </span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Discipline No" field="Discipline_No" width="80">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        <div *ngIf="dataItem.disc_No">
          {{dataItem.disc_No}}
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Panel Comments" field="panel_Comments" width="100">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        <span class="no-wrap" eipTooltip="{{dataItem.panel_Comments}}" eipTooltipPosition="auto">
          {{dataItem.panel_Comments}}
        </span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Comment Category" field="category" width="80">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        <div *ngIf="dataItem.category=='L2'" style="background-color: #ffbf00; font-weight: 900;">
          {{dataItem.category}}
        </div>
        <div *ngIf="dataItem.category=='L1'" style="background-color: red; font-weight: 900;">
          {{dataItem.category}}
        </div>
        <div *ngIf="dataItem.category=='L3'" style="background-color: green; font-weight: 900;">
          {{dataItem.category}}
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Commented By" field="submitted_By" width="100">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        <span class="no-wrap" eipTooltip="{{dataItem.submitted_By}}" eipTooltipPosition="auto">
          {{dataItem.submitted_By}}
        </span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Commented On" field="submitted_On" width="100">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        {{dataItem.submitted_On | date:'dd-MMM-yyyy'}}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Attachments" width="80">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        <i aria-hidden ="true"  class="fa fa-paperclip fs-16 eip-mr-5 eip-link" title="Attachment" (click)="viewAttachmentClick(dataItem)"></i>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Response" field="responder_Agreed" width="100">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        <span class="no-wrap" eipTooltip="{{dataItem.responder_Agreed}}" eipTooltipPosition="auto">
          {{dataItem.responder_Agreed}}
        </span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Responded By" field="responded_By" width="100">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        <span class="no-wrap" eipTooltip="{{dataItem.responded_By}}" eipTooltipPosition="auto">
          {{dataItem.responded_By}}
        </span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Responded On" field="responded_On" width="100">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        {{dataItem.responded_On | date:'dd-MMM-yyyy'}}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Action Remarks" field="action_Remarks" width="100">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        <span class="no-wrap" eipTooltip="{{dataItem.action_Remarks}}" eipTooltipPosition="auto">
          {{dataItem.action_Remarks}}
        </span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Action By" field="action_By" width="100">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        {{dataItem.action_By}}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Action On" field="action_Date" width="100">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        {{dataItem.action_Date | date:'dd-MMM-yyyy'}}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Reasons, if unable to comply" field="reason" width="100">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        <div *ngIf="dataItem.reason">
          <span class="no-wrap" eipTooltip="{{dataItem.reason}} - {{dataItem.reason_Remarks}}" eipTooltipPosition="auto">
            {{dataItem.reason}}
          </span>
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Impacts" field="impact" width="100">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        <span class="no-wrap" eipTooltip="{{dataItem.impact}}" eipTooltipPosition="auto">
          {{dataItem.impact}}
        </span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Evidence Remarks" field="evidence_Remarks" width="100">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        <div *ngIf="dataItem.responder_Agreed==='Comply'">
          <mat-form-field>
            <ng-container *ngIf="!dataItem.isSelected">
              <span class="no-wrap" eipTooltip="{{dataItem.evidence_Remarks}}" eipTooltipPosition="auto">
                <input matInput [readonly]="!dataItem.isSelected" value={{dataItem.evidence_Remarks}}>
              </span>
            </ng-container>
            <ng-container *ngIf="dataItem.isSelected">
              <textarea matInput value={{dataItem.evidence_Remarks}} (change)="onValueChange($event, dataItem);" cols="30"></textarea>
            </ng-container>
          </mat-form-field>
        </div>
        <div *ngIf="dataItem.responder_Agreed==='Unable to comply'">
          {{dataItem.evidence_Remarks}}
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Attachments for Impacts" width="100">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        <div *ngIf="dataItem.responder_Agreed==='Comply'">
          <i aria-hidden ="true"  class="fa fa-paperclip fs-16 eip-mr-5 eip-link" title="View Attachment" (click)="viewImpactAttachmentClick(dataItem)" style="margin-right: 20px;">
            </i>
            <i aria-hidden ="true"  class="fa fa-upload fs-16 eip-mr-5 eip-link" title="Upload Attachment" (click)="uploadAttachmentClick(dataItem)"></i>
        </div>
        <div *ngIf="dataItem.responder_Agreed==='Unable to comply'">
          NIL
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-excel fileName="PeerReviewImpacts.xlsx" [fetchData]="allData"></kendo-grid-excel>
  </kendo-grid>
</div>
<div class="row justify-content-center flex-grow-1">
  <button class="btn btn-primary" *ngIf="saveflag" style="margin-right: 25px;" id="btnUpdate" (click)="Save()">
      Partial Save
  </button>
  <button class="btn btn-primary" *ngIf="submitflag" id="btnUpdate" (click)="Submit()">
      Final Submit
  </button>
</div>
<div class="col-12" style="margin-top: 50px;">
  <div>
      <div style="width: 40px; height: 20px; margin-right:25px; background-color: red; position:relative; float:left;"></div>
      <div>
          <p>L1* - Red colour :High Risk comment related to major deviation from Codes/Standards, Employer’s & Contract requirements, DBR, Statutory, EHS and Security.</p>
      </div>
  </div>
  <div>
      <div style="width: 40px; height: 20px; margin-right: 25px; background-color: #ffbf00; position:relative; float:left;"></div>
      <div>
          <p>L2 - Amber colour: Medium Risk comments related to Interface and coordination issues, Alternate solutions for cost-time effectiveness. Comments not in Red and Green will be categorised to Amber.</p>
      </div>
  </div>
  <div>
      <div style="width: 40px; height: 20px; margin-right: 25px; background-color: green; position:relative; float:left;"></div>
      <div>
          <p>L3 - Green colour :Low Risk comments related to more clarity of information, typo-error, legibility issues.</p>
      </div>
  </div>
  <div>
      <div style="width: 40px; height: 20px; margin-right: 25px; background-color: white; position:relative; float:left;"></div>
      <div>
          <p>* L1 comments shall be replied before proceeding to the next stage, since its poses high risk on the end product</p>
      </div>
  </div>
  <div>
      <div style="width: 40px; height: 20px; margin-right: 25px; background-color: white; position:relative; float:left;"></div>
      <div>
          <p># Comment numbering to be prefixed with Discipline codes - Architecture -A / Structure -C/ Geotechnical- S/ Electrical -E/ ELV -L/ HVAC -V/ FPS -F/ PHE -U/ Piping -P/ CEFD -D/ Landscape -N/ General -Z</p>
      </div>
  </div>
</div>
